export default class FocalBackground {
    constructor(element) {
        this.element = element;

        this.element.style.backgroundSize = "cover";

        this.focalX = parseFloat(element.getAttribute("data-focal-x")) / 100;
        this.focalY = parseFloat(element.getAttribute("data-focal-y")) / 100;

        this.imageWidth = 0;
        this.imageHeight = 0;

        this.loadImage().then(() => {
            this.centerBackground();

            // Mitigate late layout shifts
            setTimeout(() => {
                this.centerBackground();
            }, 500);

            window.addEventListener('resize', () => {
                this.centerBackground();
            });
        });
    }

    /**
     * We need to download the image again to get its dimensions. Luckily, as
     * long as we use a regular JS Image object, most browsers will just reuse
     * their already loaded version, adding virtually no network overhead.
     *
     * We get the image url by regexing the CSS property background-image which
     * seems to be the only way as of now.
     * @returns {Promise<void>}
     */
    loadImage() {
        var imageSrc = this.element.style.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2')
            .split(',')[0];

        return new Promise((resolve, reject) => {
            var image = new Image();
            image.src = imageSrc;

            image.onload = () => {
                this.imageWidth = image.width;
                this.imageHeight = image.height;

                resolve();
            };
        });
    }

    /**
     * Since we will always use CSS background-size cover, our image will always
     * be 100% in one dimension and be movable on the other. We determine which
     * axis to move by by comparing aspect ratios of our element and the image.
     * @returns {string} Either y or x
     */
    getMoveDirection() {
        let imageRatio = this.imageWidth / this.imageHeight;
        let elementRatio = this.element.getBoundingClientRect().width / this.element.getBoundingClientRect().height;

        if (imageRatio < elementRatio) {
            return "y";
        }

        return "x";
    }

    /**
     * This function will determine the pixel value of the necessary shift to get
     * our focal point in the center as best as we can. After calculating the shift
     * to get our focal point in total center, it also checks for bounds so the
     * image always covers the whole element.
     * @param targetAxisLength The length of the target axis, either height or width of the element
     * @param imageAxisLength The length of the image axis, either height or width - needs to be scaled to actual display dimensions
     * @param focalPoint The focal point along the image axis in percent
     * @returns {number} Amount of pixels to shift the background image by
     */
    getShiftForAxis(targetAxisLength, imageAxisLength, focalPoint) {
        let maximumShift = imageAxisLength - targetAxisLength;

        let pointOfInterest = imageAxisLength * focalPoint;

        let shift = pointOfInterest - targetAxisLength / 2;

        if (shift > maximumShift) {
            shift = maximumShift;
        }

        if (shift < 0) {
            shift = 0;
        }

        return -1 * shift;
    }

    centerBackground() {
        let elementDimensions = this.element.getBoundingClientRect();

        let direction = this.getMoveDirection();

        if (direction === "x") {
            let targetAxisLength = elementDimensions.width;
            let imageAxisLength = elementDimensions.height / this.imageHeight * this.imageWidth;

            this.element.style.backgroundPositionY = "0";
            return this.element.style.backgroundPositionX = this.getShiftForAxis(targetAxisLength, imageAxisLength, this.focalX) + "px";
        }

        let targetAxisLength = elementDimensions.height;
        let imageAxisLength = elementDimensions.width / this.imageWidth * this.imageHeight;

        this.element.style.backgroundPositionX = "0";
        return this.element.style.backgroundPositionY = this.getShiftForAxis(targetAxisLength, imageAxisLength, this.focalY) + "px";
    }
}